import FormField from "@/components/ui/form-field";
import S from "../../index.module.scss";
import { LOGIN_FORM_FIELDS } from "./constants";
import { Dialog } from "radix-ui";
import { Dispatch, FC, SetStateAction } from "react";
import { useLoginData } from "../../hooks/useLoginData";
import { ModalStateType } from "../../types";
import { FormProvider } from "react-hook-form";

interface ILoginForm {
  setState: Dispatch<SetStateAction<ModalStateType>>;
  handleClose: (isOpen: boolean) => void;
  redirectTo?: string;
}

const LoginForm: FC<ILoginForm> = ({ setState, handleClose, redirectTo }) => {
  const { onSubmit, isPending, methods } = useLoginData({ handleClose, redirectTo });

  return (
    <FormProvider {...methods}>
      <form className={S.form} onSubmit={onSubmit} noValidate>
        <Dialog.Title className={S.title}>Вход</Dialog.Title>
        <div className={S.fields}>
          {LOGIN_FORM_FIELDS.map(field => (
            <FormField key={field.id} field={field} />
          ))}
          <span className={S.resetButton} onClick={() => setState("reset_password")}>
            Восстановить пароль
          </span>
        </div>

        {methods.formState.errors.root?.serverError?.message && (
          <p className={S.error}>{methods.formState.errors.root.serverError.message}</p>
        )}

        <button type="submit" className={S.submitButton} disabled={isPending}>
          Войти
        </button>
        <span className={S.info}>
          Нет аккаунта?
          <span className={S.infoButton} onClick={() => setState("register")}>
            Зарегистрируйтесь
          </span>
        </span>
      </form>
    </FormProvider>
  );
};

export default LoginForm;
